import { CircleCheck, CircleX, Tag, Trash, User, Users } from 'lucide-react';
import LangEnum from '../../../../lang/LangEnum';
import { catalogBulkAction } from '../../components/CatalogListMassActions/CatalogBulkActionButton';

interface BuildCatalogMassActionsParams {
  isActivateHidden: boolean;
  isInactivateHidden: boolean;
  isRemoveHidden: boolean;
}

export const buildCatalogMassActions = ({
  isActivateHidden,
  isInactivateHidden,
  isRemoveHidden,
}: BuildCatalogMassActionsParams) => {
  return [
    catalogBulkAction({
      type: 'activate_batch',
      label: LangEnum.CATALOGS_BULK_MENU_ACTIVATE,
      icon: CircleCheck,
      active: !isActivateHidden,
    }),
    catalogBulkAction({
      type: 'inactivate_batch',
      label: LangEnum.CATALOGS_BULK_MENU_DEACTIVATE,
      icon: CircleX,
      active: !isInactivateHidden,
    }),
    catalogBulkAction({
      type: 'remove_batch',
      label: LangEnum.CATALOGS_BULK_MENU_DELETE,
      icon: Trash,
      active: !isRemoveHidden,
    }),
    catalogBulkAction({
      type: 'add_customers_batch',
      label: LangEnum.CATALOGS_BULK_ADD_CUSTOMERS_MENU,
      icon: User,
      active: true,
    }),
    catalogBulkAction({
      type: 'add_reps_batch',
      label: LangEnum.CATALOGS_BULK_ADD_SALES_REPS_MENU,
      icon: Users,
      active: true,
    }),
    catalogBulkAction({
      type: 'add_classifications_batch',
      label: LangEnum.CATALOGS_BULK_ADD_CLASSIFICATIONS_MENU,
      icon: Tag,
      active: true,
    }),
  ];
};
